import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from "@dp/state";
import { Box } from "native-base";
import { observer } from "mobx-react-lite";
import { useHeaderHeight } from "../../hooks";
export var LayoutContainer = observer(function (_ref) {
  var hideGlobalBanner = _ref.hideGlobalBanner,
      children = _ref.children;
  var store = useStore();
  var isMobile = store === null || store === void 0 ? void 0 : store.isMobile;
  var headerHeight = useHeaderHeight();
  var heightOnNoBanner = isMobile ? "77px" : "91px";
  var marginHeight = hideGlobalBanner ? heightOnNoBanner : headerHeight;
  return /*#__PURE__*/_jsx(Box, {
    mt: marginHeight,
    bg: "bodyBg",
    children: children
  });
});